












import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { RatesModule } from '@/store/dashboard/rates/RatesModule';
import { resolveModule } from '@/store';
import { namespace } from 'vuex-class';
import { Building } from '@/modules/backend/Entities/Building';
import { Resource } from '@/modules/backend/Entities/Resource';
import DeleteConfirmation from '@/layouts/DeleteConfirmation.vue';
import Mixin from '@/mixins/base';

const ResourceModule = namespace('dashboard/resources');
@Component({
  mixins: [Mixin],
  components: {
    'delete-confirmation': DeleteConfirmation,
  }
})
export default class RatesResetDialog extends Mixins(Mixin) {
  @Prop({ required: true })
  private readonly building!: Building;

  private loading = false;

  private readonly ratesModule: RatesModule = resolveModule(RatesModule);

  @ResourceModule.Action('Fetch')
  private readonly fetchResources!: () => Promise<void>;

  @ResourceModule.Getter('Resources')
  private readonly resources!: Resource[];

  @Watch('loading')
  private loadingHandler(value: boolean): void {
    this.$emit('loading-changed', value);
  }

  public async confirmationOpenedHandler(): Promise<void> {
    await this.fetchResources();
  }

  private async reset(): Promise<void> {
    try {
      this.loading = true;
      await this.ratesModule.reset(this.building.getId());
    } finally {
      this.loading = false;
    }
  }
}
